import {
  ADD_DMPPLAYERS_ERROR,
  ADD_DMPPLAYERS_LOADING,
  ADD_DMPPLAYERS_SUCCESS,
  CLEAR_DMPPLAYERS,
} from "../../../constant/actionTypes";

const addDmpPlayersInMatchReducer = (
  state = { loading: false, data: {} },
  action
) => {
  switch (action.type) {
    case ADD_DMPPLAYERS_LOADING: {
      let obj = { ...state, loading: true };
      return obj;
    }
    case ADD_DMPPLAYERS_SUCCESS: {
      let obj = { loading: false, data: action.response };
      return obj;
    }
    case ADD_DMPPLAYERS_ERROR: {
      let obj = { loading: false, data: action.response };
      return obj;
    }
    case CLEAR_DMPPLAYERS: {
      let obj = { loading: false, data: {} };
      return obj;
    }

    default:
      return state;
  }
};

export default addDmpPlayersInMatchReducer;
